'use strict';
/* COMPONENT - c.06.14 Services list */

import ShopMap from './c06.01_shop-map.js';

class ServicesList extends ShopMap {
    constructor(element) {
        super(element);
        if (this.root.querySelector('.shop-details-directions')) {
            this.link = this.root.querySelector('.shop-details-directions').getElementsByTagName('a')[0];
            this.coords = this.root.querySelector('.shop-map-link').getAttribute('data-coords');
        }
    }
}

export default ServicesList;
